export default (selectedLanguage) =>
  new Promise((resolve, reject) => {
    window.axios
      .get(`${process.env.VUE_APP_API_ADMIN_LOCATION}homefeed/section?language=${selectedLanguage}`, {
        headers: {
          ignoreLoading: true,
        },
      })
      .then(({ data }) => {
        let sections = [];
        if (data) {
          sections = data.sections;
        }
        resolve(sections);
      })
      .catch((error) => {
        reject(error);
      });
  });
